import startUpDataMutations from "./mutations.js";
import startUpDataActions from "./actions.js";
import startUpDataGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            startUpDataDetails: {}
        };
    },
    mutations: startUpDataMutations,
    actions: startUpDataActions,
    getters: startUpDataGetters,
};